import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

/** The help-center article on verifying signed webhooks (PREC-4249). */
export const WEBHOOK_SIGNING_HELP_URL = "https://help.signalist.io/webhook-signatures";

/**
 * What a receiver has to do with a signed delivery (PREC-4249): the full list in the secret dialog,
 * the short one in the Edit dialog, both linking the help article.
 */
export const WebhookSignatureGuidance: FunctionComponent<{ variant: "full" | "short" }> = ({
	variant,
}) => {
	const { t } = useTranslation();
	const full = variant === "full";
	const points = full
		? ["hmac", "replay", "dedupe", "rotation"]
		: ["shortHmac", "shortReplay", "shortDedupe"];

	return (
		<div
			className="rounded-md border border-border-light bg-background-light p-3 text-xs text-text"
			data-test={`webhook-signing-guidance-${variant}`}
		>
			<div className="mb-1 font-medium">
				{t(full ? "webhookSigning.guidance.title" : "webhookSigning.guidance.shortTitle")}
			</div>
			<ul className="mb-2 list-disc pl-4">
				{points.map((point) => (
					<li key={point}>{t(`webhookSigning.guidance.${point}`)}</li>
				))}
			</ul>
			<a
				className="cursor-pointer text-brand-light underline"
				href={WEBHOOK_SIGNING_HELP_URL}
				rel="noreferrer"
				target="_blank"
			>
				{t(full ? "webhookSigning.guidance.link" : "webhookSigning.guidance.shortLink")}
			</a>
		</div>
	);
};
